const ENUM_fetchStatus = {
  initial: 'initial',
  success: 'success',
  aborted: 'aborted',
  invalid: 'invalid',
  error: 'error',
  loading: 'loading'
};


export {
  ENUM_fetchStatus
};
